import { DEFAULT_QUERY_LIMIT } from '@shared/constants';
import { Filter, FirestoreQuery, OrderBy, QueryResult } from '@shared/types';

export interface QueryState {
  conditions: Filter[];
  orConditions: Filter[];
  orderBy: OrderBy[];
  limit: number;
  documentIdPrefix?: string;
  listOrderBy: OrderBy | null;
  activeQuery: FirestoreQuery | null;
  queryResults: QueryResult | null;
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
  testRunLoading: boolean;
  testRunError: string | null;
}

export const DEFAULT_QUERY_STATE: QueryState = {
  conditions: [],
  orConditions: [],
  orderBy: [],
  limit: DEFAULT_QUERY_LIMIT,
  documentIdPrefix: undefined,
  listOrderBy: null,
  activeQuery: null,
  queryResults: null,
  loading: false,
  loadingMore: false,
  error: null,
  testRunLoading: false,
  testRunError: null,
};

export function getDefaultState(): QueryState {
  return { ...DEFAULT_QUERY_STATE };
}

export function stateReducer(prev: QueryState, patch: Partial<QueryState>): QueryState {
  return { ...prev, ...patch };
}

function validCondition(c: Filter): boolean {
  return Boolean(c.field && c.value !== '' && c.value !== null && c.value !== undefined);
}

export function buildFirestoreQuery(state: QueryState, collectionName: string): FirestoreQuery {
  const filters: Filter[] = (state.conditions ?? [])
    .filter(validCondition)
    .map((c) => ({ field: c.field, operator: c.operator, value: c.value }));
  const orFilters: Filter[] = (state.orConditions ?? [])
    .filter(validCondition)
    .map((c) => ({ field: c.field, operator: c.operator, value: c.value }));
  const orderByList: OrderBy[] = (state.orderBy ?? []).filter((o) => o.field);
  const limit = state.limit ?? DEFAULT_QUERY_LIMIT;

  return {
    collection: collectionName,
    filters: filters.length > 0 ? filters : undefined,
    orGroups: orFilters.length >= 2 ? [orFilters] : undefined,
    orderBy: orderByList.length > 0 ? orderByList : undefined,
    limit: limit > 0 ? limit : undefined,
    documentIdPrefix: state.documentIdPrefix?.trim() || undefined,
  };
}
